export const DEFAULT_THEME = 'light';
export const KEY = {
    ENTER: 'Enter',
    TAB: 'Tab',
};
export const HEADER_HEIGHT = 64;
